import { ErrorHandler, Injectable, Injector, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { BAD_REQUEST, FORBIDDEN, UNAUTHORIZED } from 'http-status-codes';
import { NotificationService } from './notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MSALAuthService } from '@app/auth/msal-auth.service';
@Injectable()
export class EcpErrorHandler implements ErrorHandler {
  static readonly DEFAULT_ERROR_MESSAGE: any = {
    title: 'We’re sorry!',
    content: 'There appears to be a problem—please try again later.',
    confirmBtnText: 'Close',
  };

  static readonly SETUP_ERROR_MESSAGE: any = {
    title: 'We`re sorry!',
    content:
      'Sorry, the location you selected is not set up correctly in our system. Please contact the Customer Support team at MEDSupport@EssilorUSA.com',
    confirmBtnText: 'Close',
  };

  static readonly RESETPW_ERROR_MESSAGE: any = {
    title: 'We’re sorry!',
    content:
      'There appears to be a problem resetting your password it has either not met the password requirements or you have tried to use a previous password from your last 14 passwords.',
    confirmBtnText: 'Close and try again',
  };

  static readonly PW_ERROR_MESSAGE: any = {
    title: 'We`re sorry!',
    content:
      'Sorry, the password reset functionality is not working. Please contact the Customer Support team at MEDSupport@EssilorUSA.com and they will reset your password promptly.',
    confirmBtnText: 'Close',
  };

  static readonly FT_ERROR_MESSAGE: any = {
    title: 'We’re sorry!',
    content:
      'There appears to be a problem uploading your frametrace. Please contact the Customer Support team at MEDSupport@EssilorUSA.com.',
    confirmBtnText: 'Close',
  };

  static readonly EA_RPT_ERROR_MESSAGE: any = {
    title: 'We’re sorry!',
    content:
      'There appears to be a problem downloading your order report extract. Please create an HDA ticket for MED MyLink Support.',
    confirmBtnText: 'Close',
  };
  constructor(private inject: Injector) {}

  private handleHttpError(error: HttpErrorResponse): void {
    const errorCode = error.status;
    const router = this.inject.get(Router);
    const notifier = this.inject.get(NotificationService);
    const authService = this.inject.get(MSALAuthService);
    switch (errorCode) {
      case UNAUTHORIZED:
        authService.logout();
        break;
      case FORBIDDEN:
        router.navigateByUrl('/');
        break;
      case BAD_REQUEST:
        notifier.error(EcpErrorHandler.DEFAULT_ERROR_MESSAGE);
        break;
      case 0:
        break;
      default:
        notifier.error(EcpErrorHandler.DEFAULT_ERROR_MESSAGE);
    }
  }

  public handleError(error: Error | HttpErrorResponse): void {
    const notifier = this.inject.get(NotificationService);
    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error);
    }
    if (isDevMode()) {
      console.error('--- ERROR HANDLER ---');
      console.error(error.message);
      console.error(error);
    }
  }
}
